// extracted by mini-css-extract-plugin
export default {"hideBreak":"whatWeOffer_hideBreak__2oC2u","hideEllipses":"whatWeOffer_hideEllipses__6jDAC","images_container":"whatWeOffer_images_container__ieHFs"};